module.exports = __webpack_public_path__ + "img/telephone.4c9ec728.svg";